<template>
  <div class="news">
    <div class="mod-title" v-show="showTitle">
      <span class="main">历史项目</span><span class="en">project</span>
    </div>
    <div class="search-box" v-if="showSearch">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input v-model="keyword" size="small" clearable placeholder="请输入关键词"></el-input>
        </el-col>
        <el-col :span="7">
          <el-select
            clearable
            v-model="newsType"
            size="small"
            collapse-tags
            style="margin-left: 20px;"
            placeholder="请选择">
            <el-option
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              v-for="item in newsTypeOption"
              :key="item.code"
              :label="item.value"
              :value="item.code">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="1">
          <el-button size="small" type="primary" @click="getNews()">搜索</el-button>
        </el-col>
        <el-col :span="10"></el-col>
      </el-row>

    </div>
    <div class="list">
      <ul>
        <li v-for="news in page.list" @click="jump('/style1/detail',{id:news.newsId})" :key="news.newsId">
          <el-tag size="small">{{ news.newsType | typeFilter }}</el-tag>
          <el-tag v-if="news.topNews === '1'" type="success" size="small">置顶</el-tag>
          <span class="title">{{ news.title }}  {{ news.projectNo }}</span>
          <span class="time">{{ news.showDate }}</span>
        </li>
        <li v-show="page.list.length === 0">暂无公告</li>
      </ul>
    </div>
    <div class="page" v-if="showPage">
      <el-pagination
        :current-page="page.currPage"
        :page-sizes="[ 10,30,50]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { get } from '@/util/Http';
import { cons, getValueBycode } from '@/util/const';

export default {
  name: 'NewsList',
  props: ['showTitle', 'showPage', 'showSearch'],
  data() {
    return {
      newsType: '',
      options: [],
      page: {
        currPage: 1,
        pageSize: 10,
        totalCount: 0,
        totalPage: 0,
        list: [],
      },
      newsTypeOption: cons.projectType,
    };
  },
  created() {
    this.getNews();
  },
  methods: {
    getNews() {
      get('/news/page', {
        keyword: this.keyword,
        newsType: this.newsType,
        topType: '2',
        enable: '1',
        page: this.page.currPage,
        limit: this.page.pageSize,
      })
        .then((result) => {
          if (result.status === 200) {
            this.page = result.data.page;
          }
          this.$store.state.search = 0;
        })
        .catch((error) => {
          console.log(error);
          this.$store.state.search = 0;
        });
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.currPage = 1;
      this.getNews();
    },
    handleCurrentChange(val) {
      this.page.currPage = val;
      this.getNews();
    },
  },
  filters: {
    typeFilter(val) {
      return getValueBycode('projectType', val);
    },
  },
};
</script>

<style scoped>

</style>
